// EVA-6902 Unit 2 — named selectors for `visDimensionsStore.ts`.
//
// Per the selector-hygiene rule (state-management.instructions.md), all
// Zustand selectors must be named exports — no inline anonymous selectors
// at call sites. `selectDimensions` is a compound selector (returns the
// whole state object) and must be consumed with `useShallow` at call
// sites that select more than one field via it.
import type { VisDimensionsState } from "./visDimensionsStore";

/** All four dimension fields as a single object — consume with `useShallow`. */
export const selectDimensions = (s: VisDimensionsState): VisDimensionsState => ({
  leftWidth: s.leftWidth,
  rightWidth: s.rightWidth,
  upHeight: s.upHeight,
  downHeight: s.downHeight
});

export const selectLeftWidth = (s: VisDimensionsState): number => s.leftWidth;
export const selectRightWidth = (s: VisDimensionsState): number => s.rightWidth;
export const selectUpHeight = (s: VisDimensionsState): number => s.upHeight;
export const selectDownHeight = (s: VisDimensionsState): number => s.downHeight;
